import { render, staticRenderFns } from "./MobileModule.vue?vue&type=template&id=4c94c527&scoped=true&"
import script from "./MobileModule.vue?vue&type=script&lang=js&"
export * from "./MobileModule.vue?vue&type=script&lang=js&"
import style0 from "./MobileModule.vue?vue&type=style&index=0&id=4c94c527&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c94c527",
  null
  
)

component.options.__file = "MobileModule.vue"
export default component.exports